import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Leistungen',
    href: '#services'
  }, {
    name: 'Beispiele',
    href: '#gallery'
  }, {
    name: 'Prozess',
    href: '#process'
  }, {
    name: 'Preise',
    href: '#pricing'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Kontakt',
    href: '#contact'
  }, {
    name: 'Über uns',
    href: '#about'
  }];
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-xl border-b border-black/5 py-4' : 'bg-transparent py-6'}`} data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <div className="flex items-center justify-between" data-id="element-95">
          <a href="#" className="text-2xl font-semibold tracking-tight text-black" onClick={e => scrollToSection(e as any, '#hero')} data-id="element-96">
            Archaitechs
          </a>

          <nav className="hidden md:flex items-center space-x-8" data-id="element-97">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-sm font-light text-neutral-500 hover:text-black transition-colors" data-id="element-98">
                {link.name}
              </a>)}
            <Button size="sm" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-99">
              Projekt anfragen
            </Button>
          </nav>

          <button className="md:hidden p-2 text-neutral-500 hover:text-black transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-100">
            {isMobileMenuOpen ? <X size={24} data-id="element-101" /> : <Menu size={24} data-id="element-102" />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white/95 backdrop-blur-xl border-b border-black/5 p-4" data-id="element-103">
          <nav className="flex flex-col space-y-4" data-id="element-104">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-base font-light text-neutral-500 hover:text-black py-2 transition-colors" data-id="element-105">
                {link.name}
              </a>)}
            <Button fullWidth onClick={() => {
          document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          });
          setIsMobileMenuOpen(false);
        }} data-id="element-106">
              Projekt anfragen
            </Button>
          </nav>
        </div>}
    </header>;
}